var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0ma{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0ma","d":"M25.5,175.4l125.3,69.3l134.4-86.5c2.2-1.4,5.1-1.1,7,0.8s2.2,4.8,0.8,7l-86.5,134.5l69.3,125.3L422.5,28.4\n\tL25.5,175.4z","key":1})]);
}

Mail.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 456 462","style":{"enableBackground":"new 0 0 456 462"},"xmlSpace":"preserve"};

module.exports = Mail;

Mail.default = Mail;
